
<script>
import BarList from '../components/bar-list.vue'
import { SysVars } from '../main';
import fpagForm from './fpag-form.vue'
export default {
  components: { FpagForm : fpagForm, BarList },
    data(){
        return {
            showForm: false, //exibe a tela de manutencao,
            fpag: '',
            crud: '',
            filter: '',
            offset:'',
            codfpag: 0,
            metadata: this.$store.getters.getEntities.metadata,
        }
    },
    computed:{
        fpagList(){
            return this.$store.getters.getFpagList
        },
        nextPage(){
            return this.$store.getters.getNextPage
        }
    },
    methods:{
        handleEdit(cod, view){
            if(view)
                this.crud = SysVars.crudView
            else
                this.crud = SysVars.crudU

            this.codfpag = cod
            this.showForm = true
        },
        handleNew(){
            this.crud = SysVars.crudI
            this.codfpag = ''
            this.showForm = true
        },
         handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },
        loadData(){
            this.$store.dispatch('loadFpag', { filter:this.filter, page: this.nexPage} )
            this.offset = ''
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
        search(value){
            //efetua a pesquisa
            let valueU = value.toUpperCase()

            this.filter = '{"$or":[{"codfpag":{"$like":"%25' + valueU + '%25"}},{"descricao":{"$like":"%25' + valueU + '%25"}}]}'
            this.loadData()
        },
        closeForm(){
            this.showForm = false
            this.loadData()
        },
        formapag(formpag){
            let descricao =  ''
            this.metadata.fpag.formapag.options.find(e=> {if(e.id == formpag){
                descricao = e.text
            }})
            return descricao
        },
        bandeirapag(bandeirapag){
            let descricao = ''
            this.metadata.fpag.bandeirapag.options.find(e => {if(e.id == bandeirapag){
                 descricao = e.text
             }} )
             return descricao
        }
    },
    created() {
        this.showForm = false
        this.loadData()
    },
}
</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Forma de Pagamento"
                plural-entity="Formas de Pagamento"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert type="norecord" v-if="fpagList.length == 0"></alert>

                <article class="nb-card" v-for="fpag in fpagList" :key="fpag.codfpag">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-credit-card" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ fpag.descricao.toUpperCase() }}</h2>
                                </div>
                                <div class="nb-card-code" v-if="fpag.codfpag">
                                    Código <strong>{{ fpag.codfpag }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                @edit="handleEdit(fpag.codfpag)"
                                @view="handleEdit(fpag.codfpag, true)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="fpag.formapag">
                            <span class="nb-card-detail-label">Tipo</span>
                            <strong>{{ formapag(fpag.formapag) }}</strong>
                        </div>
                        <div class="nb-card-detail" v-if="fpag.bandeirapag">
                            <span class="nb-card-detail-label">Bandeira</span>
                            <strong>{{ bandeirapag(fpag.bandeirapag) }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <FpagForm v-if="showForm" :index="this.codfpag" :crud="this.crud" @closeform="closeForm"></FpagForm>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/fpag-list.vue